import { useCV } from '../hooks/useCV'
import CopyEmail from './CopyEmail'
import Timeline from './Timeline'

const Hero = () => {
  const { name, summary, highlight, contact, location } = useCV()

  return (
    <section id="home" className="pt-32 sm:pt-36 pb-16 md:pb-24">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-x-10 gap-y-10 items-end">
        <div className="md:col-span-8">
          <h1 className="font-serif text-[2.6rem] leading-[1.05] sm:text-6xl lg:text-7xl font-medium tracking-tight">
            Full-stack developer with five years of experience building web products and data platforms.
          </h1>

          <p className="mt-8 text-lg leading-relaxed text-mute max-w-prose">
            {summary}
          </p>

          {highlight && (
            <p className="mt-5 text-lg leading-relaxed max-w-prose">{highlight}</p>
          )}

          <p className="mt-8 flex flex-wrap items-baseline gap-x-6 gap-y-2 text-base">
            <CopyEmail
              email={contact.email}
              linkClassName="font-medium underline underline-offset-4 decoration-accent decoration-2 hover:text-accent"
            />
            {contact.github && (
              <a href={contact.github} target="_blank" rel="noopener noreferrer" className="text-mute hover:text-ink underline underline-offset-4 decoration-rule">
                GitHub
              </a>
            )}
            {contact.linkedin && (
              <a href={contact.linkedin} target="_blank" rel="noopener noreferrer" className="text-mute hover:text-ink underline underline-offset-4 decoration-rule">
                LinkedIn
              </a>
            )}
          </p>
        </div>

        <figure className="md:col-span-4 max-w-xs md:max-w-none">
          <img
            src="/avatar.jpeg"
            alt={`Portrait of ${name}`}
            className="w-full aspect-[4/5] object-cover rounded-sm"
          />
          <figcaption className="mt-3 text-sm text-mute">{location}</figcaption>
        </figure>
      </div>

      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Timeline />
      </div>
    </section>
  )
}

export default Hero
